var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21199 2.87868C5.33331 3.75736 5.33331 5.17157 5.33331 8V16C5.33331 18.8284 5.33331 20.2426 6.21199 21.1213C7.09067 22 8.50489 22 11.3333 22H13.3333C16.1617 22 17.576 22 18.4546 21.1213C19.3333 20.2426 19.3333 18.8284 19.3333 16V8C19.3333 5.17157 19.3333 3.75736 18.4546 2.87868C17.576 2 16.1617 2 13.3333 2H11.3333C8.50489 2 7.09067 2 6.21199 2.87868ZM8.58331 17C8.58331 16.5858 8.9191 16.25 9.33331 16.25H12.3333C12.7475 16.25 13.0833 16.5858 13.0833 17C13.0833 17.4142 12.7475 17.75 12.3333 17.75H9.33331C8.9191 17.75 8.58331 17.4142 8.58331 17ZM9.33331 12.25C8.9191 12.25 8.58331 12.5858 8.58331 13C8.58331 13.4142 8.9191 13.75 9.33331 13.75H15.3333C15.7475 13.75 16.0833 13.4142 16.0833 13C16.0833 12.5858 15.7475 12.25 15.3333 12.25H9.33331ZM8.58331 9C8.58331 8.58579 8.9191 8.25 9.33331 8.25H15.3333C15.7475 8.25 16.0833 8.58579 16.0833 9C16.0833 9.41421 15.7475 9.75 15.3333 9.75H9.33331C8.9191 9.75 8.58331 9.41421 8.58331 9Z",
    fill: "#9B51E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.56856 4.05859C5.33331 4.94188 5.33331 6.17738 5.33331 8.00034V16.0003C5.33331 17.8234 5.33331 19.0589 5.56858 19.9422L5.33331 19.9243C4.35823 19.8284 3.70188 19.6116 3.21199 19.1217C2.33331 18.243 2.33331 16.8288 2.33331 14.0004V10.0004C2.33331 7.17197 2.33331 5.75775 3.21199 4.87907C3.70188 4.38919 4.35823 4.17242 5.33331 4.07651L5.56856 4.05859Z",
    fill: "#9B51E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.098 19.9422C19.3333 19.0589 19.3333 17.8234 19.3333 16.0003V8.00034C19.3333 6.17738 19.3333 4.94188 19.098 4.05859L19.3333 4.07651C20.3084 4.17242 20.9647 4.38919 21.4546 4.87907C22.3333 5.75775 22.3333 7.17197 22.3333 10.0004V14.0004C22.3333 16.8288 22.3333 18.243 21.4546 19.1217C20.9647 19.6116 20.3084 19.8284 19.3333 19.9243L19.098 19.9422Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.f39da211202efc78ff1fdb65ab4aba4c.svg";
export { ForwardRef as ReactComponent };